import { createContext } from 'react';
import {
  FEATURE_FLAG_KEYS,
  flagDefault,
  type FeatureFlagKey,
} from '@thirdsectorbee/feature-flags';

export type FeatureFlagState = Record<FeatureFlagKey, boolean>;

// Every flag at the value the deployed code assumes. This is both the provider's
// initial state and the context default, so a component rendered outside a
// provider — a test, or a subtree mounted above it — reads the deployed
// behaviour rather than crashing or silently reading `false`.
export function defaultFlagState(): FeatureFlagState {
  return Object.fromEntries(
    FEATURE_FLAG_KEYS.map((key) => [key, flagDefault(key)]),
  ) as FeatureFlagState;
}

export const FeatureFlagContext = createContext<FeatureFlagState>(defaultFlagState());
